module.exports = "/_next/static/images/1c32a417c8a453799ad5a206dba93fb4-paper-icon.svg";